export default {"src":"/_next/static/media/ExternalBusinessSupportIcon.7b7e78a0.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};